import Vue from 'vue'
import Router from 'vue-router'
import {system} from '@/router/system.route';
import {pay} from '@/router/pay.route';
import {account} from '@/router/account.route';
import {partner} from "@/router/partner.route";
import {operat} from "@/router/operat.route";
import {brokerage} from "@/router/brokerage.route";
import { payjinjian } from './payjinjian.route';


Vue.use(Router)
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const Login = () => import('@/views/Login')
const Index = () => import('@/views/Index')
const Home = () => import('@/views/Home')
const PhoneChangePwd = () => import('@/views/PhoneChangePwd')

const AppPay = () => import('@/views/appPay/index')
const notFound = () => import('@/views/404')
// const DeviceCategory = () => import('@/views/baseInfo/deviceCategory')
// const DeviceManage = () => import('@/views/baseInfo/DeviceManage')
// const DeviceModel = () => import('@/views/baseInfo/DeviceModel')
const Area = () => import('@/views/partner/Area')


let router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Login.vue',
      component: Login,
    },
    {
      path: '/password/new',
      name: 'phoneChangePwd',
      component: PhoneChangePwd,
      meta: {title: '忘记密码'}
    },
    {
      path: '/index',
      name: 'index',
      component: Index,

      // redirect:'/account/detail',
      children: [
        {
          path: '/index',
          name: '首页',
          component: Home,
          meta: {
            requireAuth: true,
            title: '首页'
          }
        },
        // {
        //   path: '/device/category',
        //   name: '设备类型',
        //   component: DeviceCategory,
        //   meta: {
        //     requireAuth: true,
        //     title: '设备类型'
        //   }
        // },
        // {
        //   path: '/device/model',
        //   name: '设备型号',
        //   component: DeviceModel,
        //   meta: {
        //     requireAuth: true,
        //     title: '设备型号'
        //   }
        // },
        // {
        //   path: '/device/manage',
        //   name: '设备管理',
        //   component: DeviceManage,
        //   meta: {
        //     requireAuth: true,
        //     title: '设备管理'
        //   }
        // },
        ...partner,
        ...system,
        ...pay,
        ...account,
        ...operat,
        ...brokerage,
      ]
    },
    {
      path: '/404',
      name: 'notFound',
      component: notFound,
      meta: {title: 'notFound'}
    },
    {
      path: '/appPay/index',
      name: '向商家付款',
      component: AppPay,
      meta: {title: '向商家付款'}
    },
    ...payjinjian
  ]
})
const windowUrl = window.location.href
let urlPath = ''
if (windowUrl.indexOf('?') !== -1) {
  urlPath = windowUrl.split("?")[1]
}
//无需登录可访问的页面
const NotLoggedInPath = ['/', '/agent/regist', '/agent/app/regist', '/password/new', "/pay/jinjian"];
router.beforeEach((to, from, next) => {
  // next();
  if (to.meta.title) {
    document.title = to.meta.title;
  } else {
    document.title = '店播云支付平台';
  }
  var userInfo = window.localStorage.getItem('SYSUSER');
  if (!userInfo) {
    //是否存在无需登录可访问的页面
    let result = NotLoggedInPath.some(url => {
      return url == to.path
    })
    if (result) {//存在无需登录可访问的页面,则放过
      next();
    } else {//不存在
      NotLoggedInPath.push('/')
      next('/?' + urlPath);
    }
  } else {
    if (to.matched.length === 0) { // 如果未匹配到路由
      next('/404');
    } else {
      next();
    }
  }
});
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js